


























import { Component, Vue } from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';

@Component
export default class UserMenu extends Vue {
  public visible = false;
  public displayName = ConfigService.getDisplayName();
  public keycloakAccountUrl = ConfigService.getKeycloakAccountUrl();

  public toggleMenu() {
    this.visible = !this.visible;
  }

  public focusOut(event) {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      this.visible = false;
    }
  }
}
